<template>
  <div class="banner py-2">
    <slot></slot>
    <i
      class="close-rounded-icon"
      @keydown.enter="dismiss"
      @click="dismiss"
      title="close"
      tabindex="0"
      v-if="dismissible"
    ></i>
  </div>
</template>

<script>
import { storageFlags } from '@/utils/storageUtils'

/**
 * This component gives a banner
 *  Banner can be dismissible. flagName is the property name maintained in localStorage to track if banner was dismissed
 */
export default {
  name: 'Banner',
  props: {
    dismissible: Boolean,
    flagName: String
  },
  components: {},
  data() {
    return {}
  },
  computed: {},
  methods: {
    dismiss() {
      storageFlags.set(this.flagName)
      this.$emit('dismiss')
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
.banner {
  background: linear-gradient(92deg, #eaf7ff 3.7%, #fcf3ff 96.5%);
  padding-right: 50px;
  position: relative;
}
.close-rounded-icon {
  @include dimension(30px, 30px);
  position: absolute;
  right: 10px;
  top: 5px;
}
</style>
